import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { url_servicios } from 'src/app/config/config';
import { NoteBcbaV2, NoteRbtV2 } from 'src/app/core/models';
import { LocationLogFilter } from '../location/models/locations.model';
import {
  ClientReportByLocation,
  ClientReportConfig,
} from './client-report.model';

type LegacyClientReportResponse = {
  arrayPages: unknown[];
  patient: {
    full_name?: string;
    patient_identifier?: string;
    patient_id?: unknown;
    insurer_identifier?: string;
    insurer_id?: unknown;
    pa_services?: unknown;
    rbt_id?: unknown;
    rbt2_id?: unknown;
    bcba_id?: unknown;
    bcba2_id?: unknown;
  };
  noteRbts: Array<{
    supervisor?: string;
    tecnicoRbts?: string;
  }>;
  noteBcbas: unknown[];
  pos_covered: unknown;
  doctor: {
    doctor_id?: unknown;
  };
  doctors: unknown;
  pa_services?: unknown;
  patient_id?: unknown;
};

@Injectable({
  providedIn: 'root',
})
export class ClientReportService {
  private http = inject(HttpClient);

  listClientReports() {
    const URL = url_servicios + '/client_report';
    return this.http.get<LegacyClientReportResponse>(URL);
  }

  // listClientReportsSearch(page:number=1, search:string='', provider_name_g:number=0,session_date:string= ''){
  //   const headers = new HttpHeaders({'Authorization': 'Bearer'+this.authService.token});
  //   let LINK = "";
  //   if(search){
  //     LINK+="&search="+search;
  //   }
  //   if(provider_name_g){
  //     LINK+="&provider_name_g="+provider_name_g;
  //   }
  //   if(session_date){
  //     LINK+="&session_date="+session_date;
  //   }
  //   const URL = url_servicios+'/client_report?page='+page+LINK;
  //   return this.http.get<any>(URL, {headers:headers});
  // }

  listClientReportsSearch(
    page = 1,
    search_doctor = '',
    search_patient = '',
    // speciality_id:number=0,
    date_start = '',
    date_end = '',
    patient_id = null
  ) {
    void patient_id;
    let LINK = '';
    if (search_doctor) {
      LINK += '&search_doctor=' + search_doctor;
    }
    if (search_patient) {
      LINK += '&search_patient=' + search_patient;
    }
    // if(speciality_id){
    // LINK+="&speciality_id="+speciality_id;
    // }
    if (date_start) {
      LINK += '&date_start=' + date_start;
    }
    if (date_end) {
      LINK += '&date_end=' + date_end;
    }
    const URL =
      url_servicios + '/client_report/byprofile/?page=' + page + LINK + '/';
    return this.http.get<LegacyClientReportResponse>(URL);
  }

  config() {
    const URL = url_servicios + '/client_report/config';
    return this.http.get<ClientReportConfig>(URL);
  }
  getClientReport(id: number | string) {
    const URL = url_servicios + '/client_report/show/' + id;
    return this.http.get<LegacyClientReportResponse>(URL);
  }

  editClientReport(data: unknown, client_id: number | string) {
    const URL = url_servicios + '/client_report/update/' + client_id;
    return this.http.post(URL, data);
  }
  deleteClientReport(patient_id: number | string) {
    const URL = url_servicios + '/client_report/destroy/' + patient_id;
    return this.http.delete(URL);
  }

  showClientReportbyPatient(patient_id: number | string) {
    const URL = url_servicios + '/client_report/byprofile/' + patient_id;
    return this.http.get<LegacyClientReportResponse>(URL);
  }

  getAllClientReportByPatient(
    patient_id = '',
    page = 1,
    date_start = '',
    date_end = '',
    noteType?: string
  ) {
    let LINK = '';

    if (date_start) {
      LINK += '&date_start=' + date_start;
    }
    if (date_end) {
      LINK += '&date_end=' + date_end;
    }
    if (noteType) LINK += `&noteType=${noteType}`;
    const URL =
      url_servicios +
      '/client_report/byprofile/' +
      patient_id +
      '/?page=' +
      page +
      LINK;
    return this.http.get<LegacyClientReportResponse>(URL);
  }

  getAllClientReportByLocation(
    location_id: number,
    queryParams: Partial<LocationLogFilter>
  ) {
    const paramsNotNull: { [key: string]: string | number } = {};
    Object.keys(queryParams).forEach((rawKey) => {
      const key = rawKey as keyof LocationLogFilter;
      const value = queryParams[key];
      if (value !== undefined && value !== null && value !== '') {
        paramsNotNull[rawKey] = `${value}`;
      }
    });
    const params = new HttpParams({
      fromObject: paramsNotNull,
    }).toString();

    const URL = `${url_servicios}/client_report/bylocation/${location_id}?${params}`;
    return this.http.get<ClientReportByLocation>(URL).pipe(
      map((response) => {
        response.noteRbts =
          response.noteRbts?.map((item) => new NoteRbtV2(item)) ?? [];
        response.noteBcbas =
          response.noteBcbas?.map((item) => new NoteBcbaV2(item)) ?? [];
        return response;
      })
    );
  }

  getAllClientReportEmployeeByPatient(
    doctor_id = '',
    patient_id = '',
    page = 1,
    date_start = '',
    date_end = '',
    noteType?: string
  ) {
    let LINK = '';

    if (date_start) {
      LINK += '&date_start=' + date_start;
    }
    if (date_end) {
      LINK += '&date_end=' + date_end;
    }
    if (noteType) LINK += `&noteType=${noteType}`;
    const URL =
      url_servicios +
      '/client_report/byemployee/' +
      doctor_id +
      '/' +
      patient_id +
      '/?page=' +
      page +
      LINK;
    return this.http.get<LegacyClientReportResponse>(URL);
  }

  showClientReportProfile(patient_id: number | string) {
    const URL = url_servicios + '/client_report/profile/' + patient_id;
    return this.http.get<LegacyClientReportResponse>(URL);
  }

  create(data: unknown) {
    const URL = url_servicios + '/client_report/store';
    return this.http.post(URL, data);
  }
  udpate(data: unknown, client_id: number | string) {
    const URL = url_servicios + '/client_report/update/' + client_id;
    return this.http.post(URL, data);
  }
}
